import { defineTokens } from '@chakra-ui/react/styled-system';

const colors = defineTokens.colors({
  white: {
    '10': { value: 'rgba(255, 255, 255, 0.1)' },
    '15': { value: 'rgba(255, 255, 255, 0.15)' },
    '20': { value: 'rgba(255, 255, 255, 0.2)' },
    '30': { value: 'rgba(255, 255, 255, 0.3)' },
    '40': { value: 'rgba(255, 255, 255, 0.4)' },
    '50': { value: 'rgba(255, 255, 255, 0.5)' },
    '60': { value: 'rgba(255, 255, 255, 0.6)' },
    '70': { value: 'rgba(255, 255, 255, 0.7)' },
    '80': { value: 'rgba(255, 255, 255, 0.8)' },
    '85': { value: 'rgba(255, 255, 255, 0.85)' },
    '90': { value: 'rgba(255, 255, 255, 0.9)' },
    '100': { value: 'rgb(255, 255, 255)' },
  },
  neutral: {
    '10': { value: '#201b22' },
    '20': { value: '#362d39' },
    '30': { value: '#49404f' },
    '40': { value: '#6b6071' },
    '50': { value: '#7d7184' },
    '60': { value: '#94879b' },
    '70': { value: '#afa4b4' },
    '80': { value: '#c9c1cd' },
    '90': { value: '#dfdae1' },
    '93': { value: '#efebef' },
    '95': { value: '#f6f4f6' },
    '100': { value: '#fff' },
  },
  'neutral-dark': {
    '10': { value: '#f7f7f8' },
    '20': { value: '#e5e4e7' },
    '30': { value: '#ccc8d0' },
    '40': { value: '#b4aebc' },
    '50': { value: '#a199ad' },
    '60': { value: '#8d859d' },
    '70': { value: '#605874' },
    '80': { value: '#48425c' },
    '90': { value: '#2f2c44' },
    '93': { value: '#212037' },
    '95': { value: '#141629' },
    '100': { value: '#0f101f' },
  },
  purple: {
    '10': { value: '#2b0e3f' },
    '20': { value: '#421560' },
    '30': { value: '#5c2a7e' },
    '40': { value: '#7b3ba5' },
    '50': { value: '#9247c2' },
    '60': { value: '#ae63de' },
    '70': { value: '#c289e6' },
    '80': { value: '#d5adeb' },
    '90': { value: '#ead4f2' },
    '93': { value: '#f3e7f9' },
    '95': { value: '#f9f2fd' },
  },
  indigo: {
    '10': { value: '#1f1844' },
    '20': { value: '#2d2363' },
    '30': { value: '#423786' },
    '40': { value: '#5a50b2' },
    '50': { value: '#6d65d6' },
    '60': { value: '#8281ec' },
    '70': { value: '#9ca1f8' },
    '80': { value: '#b7bffc' },
    '90': { value: '#cdd5fe' },
    '93': { value: '#e5e9fa' },
    '95': { value: '#f1f4fd' },
  },
  red: {
    '10': { value: '#47060c' },
    '20': { value: '#630811' },
    '30': { value: '#78111c' },
    '40': { value: '#a91e2e' },
    '50': { value: '#d72d40' },
    '60': { value: '#f7596c' },
    '70': { value: '#ff8091' },
    '80': { value: '#ffa8b5' },
    '90': { value: '#ffccd5' },
    '93': { value: '#ffe5eb' },
    '95': { value: '#fff0f3' },
  },
  orange: {
    '10': { value: '#421000' },
    '20': { value: '#661900' },
    '30': { value: '#7a2200' },
    '40': { value: '#a33500' },
    '50': { value: '#d45202' },
    '60': { value: '#ed720c' },
    '70': { value: '#fd9730' },
    '80': { value: '#ffb766' },
    '90': { value: '#ffd5a3' },
    '93': { value: '#ffe9cf' },
    '95': { value: '#fff4e5' },
  },
  yellow: {
    '10': { value: '#2e1c00' },
    '20': { value: '#4d2f00' },
    '30': { value: '#613e00' },
    '40': { value: '#875b00' },
    '50': { value: '#b27e00' },
    '60': { value: '#d6a200' },
    '70': { value: '#ebba00' },
    '80': { value: '#f9cc15' },
    '90': { value: '#fbe074' },
    '93': { value: '#ffefad' },
    '95': { value: '#fff6d1' },
  },
  green: {
    '10': { value: '#042a0f' },
    '20': { value: '#064217' },
    '30': { value: '#0b5620' },
    '40': { value: '#167231' },
    '50': { value: '#2a9d4c' },
    '60': { value: '#4eb76c' },
    '70': { value: '#77cf8f' },
    '80': { value: '#a1deb2' },
    '90': { value: '#c3eace' },
    '93': { value: '#e1f4e7' },
    '95': { value: '#eef9f1' },
  },
  turquoise: {
    '10': { value: '#002924' },
    '20': { value: '#003d36' },
    '30': { value: '#005248' },
    '40': { value: '#007366' },
    '50': { value: '#009e8e' },
    '60': { value: '#11bba9' },
    '70': { value: '#55cec3' },
    '80': { value: '#8ae0d7' },
    '90': { value: '#aeefe8' },
    '93': { value: '#d8f8f4' },
    '95': { value: '#e9fbf9' },
  },
  blue: {
    '10': { value: '#002442' },
    '20': { value: '#00315c' },
    '30': { value: '#044781' },
    '40': { value: '#1066ac' },
    '50': { value: '#2582d0' },
    '60': { value: '#4f9bde' },
    '70': { value: '#71b8ef' },
    '80': { value: '#99d1f5' },
    '90': { value: '#c2e7fa' },
    '93': { value: '#def2fc' },
    '95': { value: '#ecf8fd' },
  },
});

export default colors;
